import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { NavBar } from "@shared/components/nav-bar/nav-bar";

@Component({
  selector: 'app-pacientes',
  imports: [RouterOutlet, NavBar],
  templateUrl: './pacientes.html',
  styleUrl: './pacientes.css',
})
export class Pacientes {}
